import SideDrawer from "components/SideDrawer";
import { useMeetingDetailQuery } from "features/Resources/Meeting/hooks";
import { Meeting } from "features/Resources/Meeting/models";
import MeetingDetails from "./MeetingDetails";

interface MeetingDetailDrawerProps {
  meeting: Meeting | null;
  onClose: () => void;
  size?: string;
  showEditLink?: boolean;
  journeyStartDate?: Date | string;
}

export default function MeetingDetailDrawer({
  meeting,
  onClose,
  size = "md",
  showEditLink = true,
  journeyStartDate,
}: MeetingDetailDrawerProps) {
  const { data: detail, isLoading } = useMeetingDetailQuery(meeting?.id, { enabled: !!meeting });
  const resolved = detail ?? meeting;

  return (
    <SideDrawer<Meeting>
      isOpen={!!meeting}
      onClose={onClose}
      item={resolved ?? undefined}
      isLoading={isLoading}
      size={size}
    >
      {({ item }) => (item ? <MeetingDetails meeting={item} showEditLink={showEditLink} journeyStartDate={journeyStartDate} /> : null)}
    </SideDrawer>
  );
}
